import type { Link } from '@packages/domain/models/link';
import { API_URL_V3, PAYEX_URL } from 'constants/config';

export const normalizeDomain = (link: Link) => {
  const splittedURL = link.href.split(API_URL_V3);
  if (splittedURL.length > 1) {
    const newHref = API_URL_V3 + splittedURL[1];
    return { ...link, href: newHref };
  } else {
    const splittedURL = link.href.split(PAYEX_URL);
    if (splittedURL.length > 1) {
      const newHref = PAYEX_URL + splittedURL[1];
      return { ...link, href: newHref };
    } else {
      return link;
    }
  }
};
